import { useWorkspaceFeatureFlags } from "src/contexts/global/WorkspaceContext";

/**
 * Centralized feature flag hooks for OD Demo features in Org Chart.
 *
 * These hooks control OD Demo-specific features that can be removed together
 * when the enableDemoODOptions and enableShowDiffInOrgChart feature flags are deprecated.
 *
 * To remove OD Demo features:
 * - Delete this directory: src/components/OrgChart/odDemo/
 * - Remove ChangelogView usage from OrgChartPanel
 * - Remove ChangelogButton from ViewOptions
 * - Remove MetricsPanel usage from OrgChartPanel
 * - Remove TeamInsightsTab from TeamDetailPage
 * - Remove changelog utils from: src/components/OrgChart/utils/changelog/
 */

export const useDateDiffFeatureEnabled = () => {
  const { enableShowDiffInOrgChart } = useWorkspaceFeatureFlags();
  return enableShowDiffInOrgChart;
};

export const useTeamInsightsFeatureEnabled = () => {
  const { enableDemoODOptions } = useWorkspaceFeatureFlags();
  return enableDemoODOptions;
};

export const useChangelogFeatureEnabled = () => {
  const isDateDiffEnabled = useDateDiffFeatureEnabled();
  const isDemoODEnabled = useTeamInsightsFeatureEnabled();
  // Changelog requires both flags to be enabled
  return isDateDiffEnabled && isDemoODEnabled;
};

export const useMetricsPanelEnabled = (state) => {
  const isFeatureEnabled = useTeamInsightsFeatureEnabled();
  return isFeatureEnabled && !!state?.currentViewTeam?.id;
};
